import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { head, map, isNull, get } from 'lodash';
import moment from 'moment';
import SpendingsLandingPages from './SpendingsLandingPages';
import { SpendingsEarnings } from './SpendingsEarnings';
import { SpendingsCreateBudget } from './SpendingsCreateBudget';
import SpendingsStore from '../../stores/SpendingsStore';
import { TransactionScreen } from './TransactionScreen';

class SpendingsLandingScreen extends PureComponent {
  static propTypes = {
    content: PropTypes.object,
    spendingAccountList: PropTypes.array,
    loadSpendingPage: PropTypes.number,
    isCreateBudgetPage: PropTypes.bool,
    earnings: PropTypes.object,
    isTransactionPage: PropTypes.bool,
    isEarningPage: PropTypes.bool,
    showAccountModal: PropTypes.bool,
    getAllAccountIds: PropTypes.array,
    transactionsTagName: PropTypes.string,
    transactionPageSize: PropTypes.number,
    earningsError: PropTypes.bool,
    openFaq: PropTypes.func,
  };

  state = {
    monthPageData: SpendingsStore.spendMonthPageData(),
    budgetPageData: SpendingsStore.spendBudgetPageData(),
    spendListData: SpendingsStore.getSpendListConnectionData(),
    potValue: SpendingsStore.getmonthlyContributionPots(),
  };

  renderSpendingLandingScreen = () => {
    const {
      content,
      transactionPageSize,
      transactionsTagName,
      currentAccFlag,
      getAllAccountIds,
      showAccountModal,
      isCreateBudgetPage,
      isEarningPage,
      isTransactionPage,
      loadSpendingPage,
      earningsError,
      earnings,
    } = this.props;
    const { potValue, spendListData, monthPageData, budgetPageData } =
      this.state;
    const { earningValueFromSpend } = spendListData;
    const {
      spendPageSortedData,
      last_month: totalLastMonthValue,
      current_month: totalCurrentMonthValue,
    } = monthPageData;

    if (earningsError && isNull(get(earnings, 'period.net_income.value'))) {
      earnings.period.net_income.value = head(earningValueFromSpend);
    }

    if (isCreateBudgetPage) {
      return (
        <SpendingsCreateBudget
          content={content}
          potValue={potValue}
          earnings={earnings}
        />
      );
    }
    if (isEarningPage) {
      return <SpendingsEarnings content={content} earnings={earnings} />;
    }
    if (isTransactionPage) {
      return (
        <TransactionScreen
          loadSpendingPage={loadSpendingPage}
          transactionPageSize={transactionPageSize}
          transactionsTagName={transactionsTagName}
          content={content}
        />
      );
    }
    const lastMonth = moment().subtract(1, 'months').format('YYYY-MM');
    const allBudgetTarget = [];
    map(budgetPageData, (item) => allBudgetTarget.push(item.target_amount));

    let isBudgetData = false;
    const collectAllTargetAmount = [];
    map(budgetPageData, (item) =>
      collectAllTargetAmount.push(item.target_amount)
    );
    map(collectAllTargetAmount, (item) => {
      if (item > 0) {
        isBudgetData = true;
      }
    });
    return (
      <SpendingsLandingPages
        {...this.props}
        loadSpendingPage={loadSpendingPage}
        content={content}
        lastMonth={lastMonth}
        totalLastMonthValue={totalLastMonthValue}
        totalCurrentMonthValue={totalCurrentMonthValue}
        spendListData={spendPageSortedData}
        budgetData={budgetPageData}
        allBudgetTarget={allBudgetTarget}
        isNoBudget={isBudgetData}
        spendingAccountList={this.props.spendingAccountList}
        showAccountModal={showAccountModal}
        getAllAccountIds={getAllAccountIds}
        currentAccFlag={currentAccFlag}
        openFaq={this.props.openFaq}
      />
    );
  };
  render() {
    return (
      <div className="full-height">{this.renderSpendingLandingScreen()}</div>
    );
  }
}

export default SpendingsLandingScreen;
